import { Component, OnInit, NgZone } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ReferralFormService } from '../../services/referral-form.service';
import { VendorService } from '../../services/vendor.service';

@Component({
  selector: 'app-thanks-card',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './thanks-card.component.html',
  styleUrls: ['./thanks-card.component.css']
})
export class ThanksCardComponent implements OnInit {

  finalForm: any;
  payorkey = 0;
  confirmationmsg = '';
  primaryColor = '';
  referenceId = '';

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private vendorService: VendorService,
    private referralService: ReferralFormService,
    private ngZone: NgZone
  ) {
    const rawFormdata = sessionStorage.getItem('activeformdata');
    this.initializeFormData(rawFormdata);
  }

  private initializeFormData(rawFormdata: string | null): void {
    if (rawFormdata) {
      try {
        this.referralService.getFormLoadJSON();
      } catch {
        console.error('Failed to parse activeformdata');
      }
    }
    this.payorkey = parseInt(sessionStorage.getItem('payorkey') ?? '0', 10);
  }

  ngOnInit(): void {
    this.finalForm = this.fb.group({});
    this.loadConfirmationMessage();
    this.loadReferenceId();
    this.setPrimaryColor();
  }

  private setPrimaryColor(): void {
    const storedColor = localStorage.getItem('primaryCssColor');
    if (storedColor) {
      this.primaryColor = storedColor;
      document.documentElement.style.setProperty('--primary-color', this.primaryColor);
    }
  }

  private loadReferenceId(): void {
    const caseActivityKey = sessionStorage.getItem('caseActivityKey');
    if (caseActivityKey) {
      this.vendorService.getReferenceId(+caseActivityKey).subscribe({
        next: (result) => this.referenceId = (result || '').replace(/^['"]+|['"]+$/g, ''),
        error: (err) => console.error('Error loading reference ID:', err)
      });
    }
  }

  private loadConfirmationMessage(): void {
    this.vendorService.getLeadConfirmation(this.payorkey).subscribe({
      next: (result) => this.confirmationmsg = result?.Message || '',
      error: () => this.confirmationmsg = '<p style="color:red;">Unable to load confirmation message.</p>'
    });
  }

  private getSecurityCode(): string {
    let code = (sessionStorage.getItem('securityCode') || localStorage.getItem('lastSecurityCode') || '').trim().toLowerCase();

    if (!code && typeof location !== 'undefined') {
      const m = (location.hash || '').match(/#\/([^\/?#]+)/);
      if (m && m[1]) code = m[1].toLowerCase();
    }
    return code;
  }
  
  finalDetailsSubmit(): void {
    const code = ( sessionStorage.getItem('securityCode') || localStorage.getItem('lastSecurityCode') || '' ).trim().toLowerCase();
    if (!code || code === 'final') return;
    localStorage.setItem('isNewReferral', 'true');
    sessionStorage.setItem('returningFromThanksCard', 'true');
    sessionStorage.removeItem('caseActivityKey');
    sessionStorage.removeItem('submissionDone');
    localStorage.removeItem('activeformdata');
    this.router.navigateByUrl('/' + code, { replaceUrl: true });
  }
}
